import { fabricTokens } from '@design-system/tokens-runtime';
import { css } from '@linaria/core';
import type { FontColorType } from './font-styles';

const {
  semantic: {
    color: { text, icon, status },
  },
} = fabricTokens;

const primary = css`
  color: ${icon.primary};
`;

const defaultColor = css`
  color: ${text.primary};
`;

const subdued = css`
  color: ${text.muted};
`;

const light = css`
  color: ${text.secondary};
`;

const disabled = css`
  color: ${text.disabled};
`;

const white = css`
  color: ${text.on_inverted};
`;

const error = css`
  color: ${status.error.default};
`;

const success = css`
  color: ${status.success.default};
`;

const warn = css`
  color: ${status.warning.default};
`;

const inherited = css`
  color: inherit;
`;

const FONT_COLOR_CLASS: Record<FontColorType, string> = {
  primary,
  default: defaultColor,
  subdued,
  light,
  disabled,
  white,
  error,
  success,
  warn,
  inherit: inherited,
};

export const getFontColorClassName = (color: FontColorType) => FONT_COLOR_CLASS[color] ?? FONT_COLOR_CLASS.default;
